import * as z from "zod/v4";

export const getCommentsoldIntegration = {
  name: "getCommentsoldIntegration" as const,
  input: z.object({}),
  output: z
    .object({
      enabled: z.boolean(),
      team: z.string(),
      shop: z.string(),
      returnsEnabled: z.boolean(),
      omsEnabled: z.boolean(),
      marketingEnabled: z.boolean(),
    })
    .optional(),
};
